<div class="bg--lightgrey u-pt50 u-pb70 full-size">
  <div class="container">
    <div class="row" *ngIf="state">
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <img  class="icon u-mb30" src="assets/img/icon-bad.png" alt="">
          <h2 class="u-mb30 txt txt--subtitle">
            {{state.name}}
          </h2>
        </div>
      </div>
      <div class="col-md-8 offset-md-2">
        <div class="u-center">

          <div class="box box--white u-mb40 u-mt20 backgroundGrey" >
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <p *ngFor="let text of state.message.split('\n')" class="txt txt-paragraph u-mb0">
                  {{text}}
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="state.buttonAction === 'CHANGE_USER'" class="">
            <button type="button" (click)="logout()" class="btn btn--primary">Cambiar de usuario</button>
          </div>
          <div *ngIf="state.buttonAction === 'DOWNLOAD_ERROR_LOG'" class="">
            <div type="button" (click)="reloadPage()" class="btn btn--primary margin-between-buttons">Recargar página</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
